import { usePlayer } from '../../player/PlayerContext';
import { HeartIcon } from '../icons';

export default function LikeButton({ albumId, size = 22 }) {
  const { likes, toggleLike } = usePlayer();
  const liked = !!likes[albumId];
  return (
    <button
      className={`like-btn ${liked ? 'liked' : ''}`}
      onClick={(e) => { e.stopPropagation(); toggleLike(albumId); }}
      aria-label={liked ? 'Remove from likes' : 'Add to likes'}
      aria-pressed={liked}
    >
      <HeartIcon size={size} filled={liked} />
    </button>
  );
}
